import {
  ITS_MATCH,
  CLEAR_ITS_MATCH,
  NBS_WS_ITS_MATCH_RECEIVED
} from '../../constants/actions';

const initialState = {
  webSocketEvent: false,
  data: {}
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ITS_MATCH:
      return {
        data: action.data
      };
    case NBS_WS_ITS_MATCH_RECEIVED: {
      return {
        webSocketEvent: true,
        data: action.data
      };
    }
    case CLEAR_ITS_MATCH:
      return initialState;
    default:
      return state;
  }
}
